import * as React from 'react';
import * as ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import Router from './Router';

import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Keycloak from './services/Keycloak';
import * as WebFont from 'webfontloader';
import './style.scss';

import { ApolloClient, HttpLink, InMemoryCache } from 'apollo-boost';
import { ApolloLink, concat } from 'apollo-link';
import { ApolloProvider } from "react-apollo";
import { withClientState } from 'apollo-link-state';
import { persistCache, CachePersistor } from 'apollo-cache-persist';
import { defaults, resolvers, typeDefs } from './graphql';

WebFont.load({
  google: {
    families: ['Roboto:300,500,700']
  }
});

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#FF6A14'
    },
  },
});

const cache = new InMemoryCache();

const httpLink = new HttpLink({
  uri: process.env.GRAPHQL,
});

const kc = new Keycloak().getInstance();
kc.init();

const authMiddleware = new ApolloLink((operation, forward) => {
  kc.updateToken(250);

  operation.setContext({
    headers: {
      authorization: 'Bearer ' + sessionStorage.getItem('token') || null,
    },
    origin: {
      requestTimeout: '229s',
    },
  });

  if (forward) {
    return forward(operation);
  } else {
    return null;
  }
});

const stateLink = withClientState({ resolvers, defaults, cache, typeDefs });

export const client = new ApolloClient({
  cache,
  connectToDevTools: true,
  link: ApolloLink.from([stateLink, concat(authMiddleware, httpLink)]),
});

const persistor = new CachePersistor({
  cache,
  storage: window.localStorage
});

const lastUpdate = window.localStorage.getItem('lastUpdate')
const now = new Date();

if(lastUpdate) {
  const date = lastUpdate.split('/').map((item) => {
    return parseInt(item, 10);
  });

  if(date[0] !== now.getDay() || date[1] !== now.getMonth()) {
    persistor.purge();
    window.localStorage.setItem('lastUpdate', `${now.getDay()}/${now.getMonth()}`)
  }
} else {
  window.localStorage.setItem('lastUpdate', `${now.getDay()}/${now.getMonth()}`)
}

persistCache({
  cache,
  debug: true,
  storage: window.localStorage,
}).then(() => {
  ReactDOM.render(
    <MuiThemeProvider theme={theme}>
    <ApolloProvider client={client}>
      <div>
        <CssBaseline />
        <Router />
      </div>
    </ApolloProvider>
    </MuiThemeProvider>,
    document.getElementById('root') as HTMLElement
  );
});

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.tsx